"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgVideoOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M4.015 4.005c2.015-.007 8.977-.007 10.981 0 1.336.005 2.004.671 2.004 2v3.008l3.403-1.203c.506-.176.898-.176 1.175 0 .278.176.419.476.422.901v6.676c.017.354-.124.62-.422.797-.298.177-.645.207-1.04.09L17 15.004v3.001c0 1.333-.667 2-2 2H4.014c-1.343 0-2.014-.666-2.014-2V6.018c0-1.337.672-2.008 2.015-2.013zm-.015 2v12h11v-12H4zM20 10l-3.002 1.005v2.003L20 14v-4zM6 15.01h4c.667-.007 1 .325 1 .995 0 .67-.333 1.005-1 1.005H6c-.667 0-1-.335-1-1.005 0-.67.333-1.002 1-.995z' }))); };
exports.default = SvgVideoOutline;
//# sourceMappingURL=VideoOutline.js.map